import { Component, OnInit } from '@angular/core';
import { ApolloService } from '../../../services/apollo/apollo.service';
import { AppService } from '@app/services/app/app.service';
import { Session } from '@app/store/models/session.model';

import { ProjectRelatedVersionsService } from '@core/services/project-related-versions/project-related-versions.service';

@Component({
    selector: 'plugin-apollo-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss']
})
export class PluginApolloMainComponent implements OnInit {
    readonly GLOBAL_ACCESS_XRAY = "access_global_xray";
    readonly PLUGIN_APOLLO = "apollo";
    readonly PLUGIN_REQUEST_FEEDBACK = 'share_feedback';
    public menuApollo: any = null;

    public itemsCompare: any = null;

    public permission: boolean = false;
    public permission_feedabacks: boolean = false;

    constructor(private apollo: ApolloService, 
        private appSrv: AppService,
        private projectRVSrv: ProjectRelatedVersionsService){
        console.log(this.menuApollo);
    }

    ngOnInit(){
        this.apollo.getMenu().subscribe( tabs => {
            this.menuApollo = tabs;
        });

        this.appSrv.getSession().subscribe((session: Session) => {

            this.permission = session.options?.plugins?.some((pa: string) => pa == this.PLUGIN_APOLLO);
            this.permission_feedabacks = session.options?.plugins?.some((pa: string) => pa == this.PLUGIN_REQUEST_FEEDBACK);

            if(session.options.access.hasOwnProperty(this.GLOBAL_ACCESS_XRAY) ){
                this.permission = this.permission && session.options.access[this.GLOBAL_ACCESS_XRAY]
            }

            this.projectRVSrv.initialice(this.permission_feedabacks);

        })

    }
}
